import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

type VerticalPadding = 'none' | 'sm' | 'md' | 'lg';

export function Divider({ verticalPadding = 'none' }: { verticalPadding?: VerticalPadding }) {
    return <Line $verticalPadding={verticalPadding} />;
}

const VERTICAL_PADDING_PX: Record<VerticalPadding, number> = { none: 0, sm: 8, md: 16, lg: 24 };

const Line = styled('hr')<{ $verticalPadding: VerticalPadding }>(({ $verticalPadding }) => ({
    border: 'none',
    borderTop: `1px solid ${Colors.lightGrey}`,
    margin: 0,
    marginTop: VERTICAL_PADDING_PX[$verticalPadding],
    marginBottom: VERTICAL_PADDING_PX[$verticalPadding],
}));
